














































import Form from '@/packages/d-form';
import Vue from 'vue';
import Component from 'vue-class-component';
import DButton from '../../index';

Vue.use(Form);
Vue.use(DButton);
@Component({
  name: 'Demo1'
})
export default class Demo1 extends Vue {
  // TODO
}
